<template>
    <el-dialog
        class="detail-info-dia"
        title="执照领取信息"
        :visible.sync="isShow"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :width="dw"
        top="12vh"
    >
    <div class="licenseMain">
        <el-form :model="obj" ref="formData" :rules="rules">
            <el-form-item label-width="145px" label="注册足协/发放机构：">
                <el-row>
                    <p>{{orgInfo.orgName}}</p>
                </el-row>
            </el-form-item>
            <el-form-item label-width="145px" label="领取联系人：" >
                <p>{{orgInfo.orgUserName || '--'}}</p>
            </el-form-item>
            <el-form-item label-width="145px" label="领取联系电话：" >
                <p>{{orgInfo.orgPhone || '--'}}</p>
            </el-form-item>
            <el-form-item label-width="145px" label="领取时间：">
                <el-row>
                    <p>{{orgInfo.get_the_date }}</p>
                </el-row>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item prop="way" label="领取方式：" label-width="145px">
                        <el-select placeholder="请选择执照领取方式"  @change="changeWay" :disabled="disabled || selectWayDisabled" v-model="obj.way">
                            <el-option
                                    v-for="(item, index) in methods"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="obj.way==='mail'">
                    <el-form-item prop="postcode" label="邮编：" label-width="100px">
                       <el-input v-model.trim="obj.postcode"  :disabled="disabled" :placeholder="disabled ? '暂无邮编':'请输入邮编'"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <template v-if="obj.way==='mail'">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label-width="145px" label="收货人姓名：" prop="consignee">
                            <el-input v-model="obj.consignee" maxlength="50" :disabled="disabled" placeholder="请填写收货人姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label-width="100px" label="联系方式：" prop="phone">
                            <el-input v-model="obj.phone" :disabled="disabled" placeholder="请填写联系方式"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="收货地址：" label-width="145px" required class="inline-item-wrap" >
                    <el-form-item label-width="0px" prop="province"  class="form-input-item" >
                        <el-select v-model="obj.province" filterable :disabled="disabled" class="hide set-sel input-w150" placeholder="请选择省份"
                                   @change="provinceChange">
                            <el-option
                                    v-for="(province) in provinceList"
                                    :key="province.id"
                                    :value="province.id"
                                    :label="province.text"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="0px" prop="city" class="form-input-item" style="margin-left: 0px;margin-right:10px">
                        <el-select v-model="obj.city" @change="cityChange" filterable :disabled="disabled" placeholder="请选择市" class="hide set-sel input-w150"
                                   >
                            <el-option v-for="(city) in cityList" :key="city.id" :label="city.text" :value="city.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label-width="0px" prop="county" class="form-input-item" style="margin-right: 0;margin-left: 0px">
                        <el-select v-model="obj.county" :disabled="disabled" filterable @change="countyChange" placeholder="请选择县区" class="hide set-sel input-w150"
                                   >
                            <el-option v-for="(city) in countyList" :key="city.id" :label="city.text" :value="city.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form-item>
                <el-row>
                    <el-form-item label="详细地址：" prop="detailed_address" label-width="145px">
                        <el-input
                                v-model="obj.detailed_address"
                                maxlength="100"
                                :disabled="disabled"
                                placeholder="请输入街道详细地址，保持在100字以内"
                                type="textarea"
                                rows="2">
                        </el-input>
                    </el-form-item>
                </el-row>
            </template>
            <template v-else>
                    <el-form-item label="领取地址：" label-width="110px">
                    <p>等待注册协会通知</p>
                </el-form-item>
            </template>
        </el-form>
        <el-popover
                ref="popover"
                placement="top"
                width="200"
                trigger="click"
                v-model="visible"
               >
            <p>提交后将无法修改，确定提交吗？ </p>
            <div style="text-align: right; margin: 0;text-align: center">
                <el-button type="primary" size="mini" @click="commit">确定</el-button>
                <el-button size="mini"  type="danger" @click="visible = false">取消</el-button>
            </div>
            <div class="btns" slot="reference" v-if="!disabled">
                <el-button type="primary"  @click="visible=true"  :loading="loading" :disabled="disabled">提交</el-button>
                <el-button type="danger" @click="isShow=false" :disabled="disabled">取消</el-button>
            </div>
        </el-popover>
    </div>
    </el-dialog>
</template>

<script>
    import { area_list } from "@/assets/js/region";
    import { license_get_way_save } from "@/api/common/api";
    export default {
        name: "getLicense",
        data(){
          const rules = {
              way:  {
                  required: true,
                  message: "请选择执照领取方式",
                  trigger: "change"
              },
              province : {
                  required: true,
                  message: "请选择省份",
                  trigger: "change"
              },
              city : {
                  required: true,
                  message: "请选择市份",
                  trigger: "change"
              },
              detailed_address:{
                  required: true,
                  validator: (rule,value,callback) =>{
                      if (value){
                          callback()
                      } else{
                          callback(new Error('请填写街道详细地址'))
                      }
                  },
                  // message:'请填写街道详细地址',
                  trigger: "blur"
              },
              consignee:{
                  required: true,
                  message: "请选择收货人姓名",
                  trigger: "blur"
              },
              phone: {
                  required: true,
                  validator: (rule, val, callback) =>{
                      if (!this.$yioks.phone(val)){
                          callback( new Error('请输入有效的手机号码'))
                      } else{
                          callback()
                      }
                  },
                  trigger: "blur",
              },
              postcode:{
                  required: false,
                  validator: (rule, val, callback) =>{
                      if (!val){
                          callback()
                      } else{
                         if ( /^\d{6}$/.test(val)){
                             callback()
                         } else{
                             callback(new Error('请输入6位有效邮编'))
                         }
                      }
                  },
                  trigger: "blur",
              }
          };
          return {
              obj:{
                  way:'mail',
                  province:'',
                  provinceName:'',
                  postcode:'',
                  phone:'',
                  city:'',
                  cityName:'',
                  consignee:'',
                  detailed_address:'',
                  county:'',
                  countyName:''
              },
              loading:false,
              visible:false,
              provinceList:[],
            selectWayDisabled:true,
              cityList:[],
              countyList:[],
              methods:[
                  {
                      label: '邮寄（到付）',
                      value: 'mail'
                  },
                  {
                      label: '自取',
                      value: 'invite'
                  }
                 ],
              rules,
          }
        },
        props:{
            dw:{
                default:'650px',
                required:false,
            },
            personInfo:{
                required:false,
                type:Object
            },
            showDialog:{
                default:false,
                required:false,
            },
            disabled: {
                default:false,
                required:false,
            },
            wait_id:{
                required:true,
            },
            orgInfo:{
                required:true,
                type:Object
            }
        },
        computed:{
            isShow:{
                get(){
                    return this.showDialog
                },
                set(val){
                    this.$emit('update:showDialog',val)
                }
            }
        },
        created() {
            this.getProvinceList();
            if(this.orgInfo.license_distribute_way ==='invite_or_mail'){
              this.selectWayDisabled=false;
            }
            if (this.personInfo.get_the_way){ // 再次编辑
               const { consignee, city_name, city_id, consignee_number, postcode,county_id, county_name, get_the_way, province_name,detailed_address,province_id}=this.personInfo
                this.$set(this.obj,'provinceName',province_name)
                this.$set(this.obj,'postcode',postcode)
                this.$set(this.obj,'province',String(province_id))
                this.$set(this.obj,'consignee',consignee)
                this.provinceChange()
                this.$set(this.obj,'city',String(city_id))
                this.$set(this.obj,'cityName',city_name)
                this.cityChange()
                this.$set(this.obj,'countyName',county_name)
                this.$set(this.obj,'county',String(county_id))
                this.$set(this.obj,'phone',consignee_number)
              if(this.orgInfo.license_distribute_way ==='invite_or_mail'){
                this.$set(this.obj,'way',get_the_way)
              }else{
                this.$set(this.obj,'way',this.orgInfo.license_distribute_way)
              }
                this.$set(this.obj,'detailed_address',detailed_address)
            }else{ // 初次填写
              if(this.orgInfo.license_distribute_way ==='invite_or_mail'){
                this.$set(this.obj,'way','mail')
              }else{
                this.$set(this.obj,'way',this.orgInfo.license_distribute_way)
              }
            }
        },
        methods:{
            commit(){
                this.$refs['formData'].validate((valid)=>{
                    if (valid){
                        let data={}
                        if (this.obj.way==='mail'){
                            const {province,postcode,provinceName,city,phone,consignee,cityName,county,countyName,detailed_address,way}=this.obj
                            data = {
                                province_id:province,
                                postcode,
                                province_name:provinceName,
                                city_id: city,
                                consignee_number:phone,
                                consignee:consignee,
                                city_name: cityName,
                                county_id:county,
                                county_name:countyName,
                                detailed_address:detailed_address,
                                get_the_way:way,
                                wait_id:this.wait_id,
                            }
                        } else{
                            data = {
                                get_the_way:this.obj.way,
                                wait_id:this.wait_id,
                            }
                        }
                        this.loading=true
                        license_get_way_save(data).then(({data:{status,msg,result}})=>{
                            if (Number(status)===0){
                                this.$emit('hideDialog',true)
                            } else {
                                this.$message.error(msg
                                )
                            }
                            this.loading=false
                        }).catch(err=>{
                            this.loading=false
                            this.visible=false
                        })
                    } else{
                        this.visible=false
                        this.$message.error('请填写所有带*号的必填项')
                    }
                })
            },
            getProvinceList() {
                const vessel = [];
                for (const reg of area_list) {
                    vessel.push({
                        text: reg.regionName,
                        id: reg.id
                    });
                }
                this.provinceList = [...vessel];
            },
            provinceChange() {
                const vessel = [];
                const curProvince = area_list.find(item => {
                    return item.id === this.obj.province;
                });
                this.curProvince = curProvince;
                this.obj.city = "";
                this.obj.cityName = "";
                if (curProvince !== undefined) {
                    this.obj.provinceName= curProvince.regionName
                    for (const city of curProvince.city) {
                        vessel.push({
                            text: city.regionName,
                            id: city.id
                        });
                    }
                }
                this.cityList = [...vessel];
                this.cityChange();
            },
            cityChange(val) {
                this.obj.county='';
                this.obj.countyName='';
                const vessel = [];
                if (this.curProvince !== undefined) {
                    const curCity = this.curProvince.city.find(item => {
                        return item.id === this.obj.city;
                    });
                    if (curCity !== undefined){
                        this.obj.cityName=curCity.regionName
                    }
                    if (curCity !== undefined && curCity.county) {
                        // this.obj.cityName=curCity.regionName
                        for (const county of curCity.county) {
                            vessel.push({
                                text: county.regionName,
                                id: county.id
                            });
                        }
                    }
                }
                this.countyList = [...vessel];
            },
            countyChange(){
                const curCounty = this.countyList.find(item => {
                    return item.id === this.obj.county;
                });
                if (curCounty !== undefined){
                    this.obj.countyName=curCounty.text
                }

            },
            changeWay(val){
                this.$refs['formData'].resetFields()
                this.$set(this.obj,'way',val)
            }
        }
    }
</script>

<style scoped lang="stylus">
    .licenseMain
        .btns
            display inline-block
            margin-top 30px
            margin-left 230px
            .cancel
                margin-left 20px
        .inline-item-wrap
            .form-input-item
                float left
                margin-right 10px
                .input-w150
                    width 148px

</style>
